import proj4 from "proj4";

// PUWG 2000 zones (ETRS89 / Poland CS2000, EPSG:2176–2179) — the ONLY CRS the
// formatki API speaks. Frames live in these meters end-to-end (editor state →
// PUT frames → DXF viewport); lat/lng exists purely at the Leaflet display
// boundary, so the rectangle/angle you see IS the exact viewport geometry.
const PUWG_DEFS: Record<number, string> = {
  2176: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.999923 +x_0=5500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
  2177: "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.999923 +x_0=6500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
  2178: "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.999923 +x_0=7500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
  2179: "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.999923 +x_0=8500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
};

function converter(srid: number) {
  const def = PUWG_DEFS[srid];
  if (!def) throw new Error(`Nieobsługiwana strefa PUWG: ${srid}`);
  // proj4(def): forward = WGS84 [lng,lat] → PUWG [x,y]; inverse = the reverse.
  return proj4(def);
}

export function puwgToLatLng(srid: number, xy: [number, number]): { lat: number; lng: number } {
  const [lng, lat] = converter(srid).inverse([xy[0], xy[1]]);
  return { lat, lng };
}

export function latLngToPuwg(srid: number, ll: { lat: number; lng: number }): [number, number] {
  const [x, y] = converter(srid).forward([ll.lng, ll.lat]);
  return [x, y];
}
